import { KeycloakService } from 'keycloak-angular';
import { environment } from '../environments/environment';

export function initializer(keycloak: KeycloakService): () => Promise<any> {
    return (): Promise<any> => {
        return new Promise(async (resolve, reject) => {
            try {
                await keycloak.init({
                    config: environment.keycloak,
                    initOptions: {
                        onLoad: 'login-required',
                    },
                    loadUserProfileAtStartUp: true,
                    enableBearerInterceptor: true,
                    shouldAddToken: (request) => {
                        return request.url.includes(environment.api);
                    }
                });
                resolve(true);
            } catch (error) {
                reject(error);
            }
        });
    };
}
